import { useTypedSearchParams } from '@/hook';
import { VFlex } from '@/package';
import { VPagination } from '@/package/kiska/src/component/UI/VPagination';
import type { FrameSearchParams } from '@/type';

const FrameListPagination = ({ count }: { count: number }) => {
  const { get, set, flush } = useTypedSearchParams<FrameSearchParams>();
  const limit = Number(get('frameLimit'));
  const offset = Number(get('frameOffset'));

  const currentPage = Math.floor(offset / (limit || 1)) + 1;
  const totalPage = Math.ceil((count || 0) / (limit || 1));

  return (
    <>
      {!!count && (
        <VFlex justify="center" className="">
          <VPagination
            currentPage={currentPage}
            totalPage={totalPage}
            onChange={page => {
              set('frameOffset', `${(page - 1) * limit}`);
              flush();
            }}
          />
        </VFlex>
      )}
    </>
  );
};

export default FrameListPagination;
